import Car from "./lootbox-car.png";
import BrightLogo from "./lootbox-bright.png";
import BlurLogoSm from "./lootbox-blur-sm.png";
import BlurLogoLg from "./lootbox-blur-lg.png";
import SuperBlurLogo from "./lootbox-super-blur.png";
import SilverBlurLogo from "./lootbox-silver-blur.png";
import Watch from "./lootbox-watch.png";
import BrightStar from "./lootbox-star.png";
import SilverStarBlur from "./lootbox-silver-star.png";
import StreetWear from "./lootbox-streetwear.png";
import Jacket from "./lootbox-jacket.png";
import DailyKick from "./lootbox-daily-kick.png";
import Shoes from "./lootbox-shoes.png";

const LootboxAnimatedBg = () => {
  return (
    <svg viewBox="0 0 1714 649" xmlns="http://www.w3.org/2000/svg">
      {/* LEFT SIDE */}
      <g transform="translate(.000001 0)">
        <image
          width="350"
          height="350"
          href={BrightLogo.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 0.415418 503.431437)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="450"
          height="450"
          href={Watch.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 130.415418 330.431437)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="30"
          height="30"
          href={BrightStar.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 450.415418 400.431437)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="600"
          height="600"
          href={StreetWear.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 250.415418 80.431437)"
        />
      </g>

      <g transform="translate(.000001 0)">
        <image
          width="30"
          height="30"
          href={BrightStar.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 600.415418 200.431437)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="450"
          height="450"
          href={Car.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 200.415418 -50.431437)"
        />
      </g>

      <g transform="translate(.000001 0)">
        <image
          width="450"
          height="450"
          href={BlurLogoSm.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 0.415418 50.431437)"
        />
      </g>

      {/* MIDDLE SIDE */}

      <g transform="translate(.000001 0)">
        <image
          width="350"
          height="350"
          href={SuperBlurLogo.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 600.415418 350.431437)"
        />
      </g>

      <g transform="translate(.000001 0)">
        <image
          width="50"
          height="50"
          href={SilverStarBlur.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 1100.415418 400.431437)"
        />
      </g>

      {/* RIGHT SIDE */}

      <g transform="translate(.000001 0)">
        <image
          width="350"
          height="350"
          href={Jacket.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 1200.415418 0.431437)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="450"
          height="450"
          href={BlurLogoLg.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 1400.415418 0.431437)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="600"
          height="600"
          href={DailyKick.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 1300.415418 150.431437)"
        />
      </g>

      <g transform="translate(.000001 0)">
        <image
          width="60"
          height="60"
          href={BrightStar.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 1300.415418 250.431437)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="300"
          height="300"
          href={SilverBlurLogo.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 1500.415418 350.431437)"
        />
      </g>

      <g transform="translate(.000001 0)">
        <image
          width="450"
          height="450"
          href={Shoes.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(.52 0 0 0.42 1350.415418 450.431437)"
        />
      </g>
    </svg>
  );
};

export { LootboxAnimatedBg };
